(function () {
  'use strict';

  let sections = document.querySelectorAll('.compare-knife-series');
  sections.forEach(initSection);

  function initSection(sectionEl) {
    let slides = sectionEl.querySelectorAll('.compare-knife-series__slide');
    if (!slides.length) return;

    let default1 = 0;
    let default2 = 1;
    let lockedBtn = sectionEl.querySelector('.compare-knife-series__slot-btn--locked');
    if (lockedBtn) default1 = parseInt(lockedBtn.dataset.seriesIndex, 10) || 0;
    slides.forEach(function (s) {
      let badge = s.querySelector('[data-badge-b]');
      if (badge && badge.classList.contains('is-visible')) {
        default2 = parseInt(s.dataset.seriesIndex, 10);
      }
    });

    let state = {
      series1: default1,
      series2: default2
    };

    setupCarousel(sectionEl, slides, state);
    setupSpecsAccordion(sectionEl);
  }

  function setupCarousel(section, slides, state) {
    let scrollContent = section.querySelector('.compare-knife-series__scroll-content');
    let scrollLine = section.querySelector('.compare-knife-series__scroll-line');
    if (!scrollContent || !scrollLine) return;

    let contentWidth = scrollContent.scrollWidth / 2;
    let speed = 30;
    let duration = contentWidth / speed;

    scrollContent.style.setProperty('--cks-scroll-width', '-' + contentWidth + 'px');
    scrollContent.style.setProperty('--cks-scroll-duration', duration + 's');
    scrollContent.classList.add('is-scrolling');

    let btn2 = section.querySelector('[data-slot="series2"]');
    let btn2Icon = btn2 ? btn2.querySelector('[data-slot-icon="series2"]') : null;
    let btn2Name = btn2 ? btn2.querySelector('[data-slot-name="series2"]') : null;

    if (btn2) {
      btn2.addEventListener('click', function () {
        scrollLine.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    let stickyHeader = section.querySelector('.compare-knife-series__sticky-header');
    let buttonsContainer = section.querySelector('.buttons-container');
    if (stickyHeader && buttonsContainer) {
      function syncSticky() {
        var icon1 = section.querySelector('[data-slot-icon="series1"]');
        var icon2 = section.querySelector('[data-slot-icon="series2"]');
        stickyHeader.innerHTML =
          '<div class="compare-knife-series__sticky-col">' + (icon1 ? icon1.innerHTML : '') + '</div>' +
          '<div class="compare-knife-series__sticky-col">' + (icon2 ? icon2.innerHTML : '') + '</div>';
      }
      syncSticky();
      stickyHeader._sync = syncSticky;
      stickyHeader.addEventListener('click', function () {
        scrollLine.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var buttonsVisible = true;
      var tableVisible = true;
      function updateStickyVisibility() {
        stickyHeader.classList.toggle('is-visible', !buttonsVisible && tableVisible);
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === buttonsContainer) {
            buttonsVisible = entry.isIntersecting;
          } else {
            tableVisible = entry.isIntersecting;
          }
        });
        updateStickyVisibility();
      }, { threshold: 0, rootMargin: '-150px 0px 0px 0px' });
      observer.observe(buttonsContainer);
      var tableWrap = section.querySelector('.compare-knife-series__table-wrap');
      if (tableWrap) observer.observe(tableWrap);
    }

    let isDragging = false;
    let didDrag = false;
    let startX = 0;
    let scrollOffset = 0;
    let dragRAF = null;
    let pendingDiff = 0;

    function wrapOffset(offset) {
      let o = offset % contentWidth;
      if (o > 0) o -= contentWidth;
      return o;
    }

    function getAnimTranslateX() {
      let transform = getComputedStyle(scrollContent).transform;
      if (!transform || transform === 'none') return 0;
      let match = transform.match(/matrix.*\((.+)\)/);
      return match ? parseFloat(match[1].split(',')[4]) : 0;
    }

    function pauseAnimation() {
      scrollOffset = getAnimTranslateX();
      scrollContent.classList.add('is-dragging');
      scrollLine.classList.add('is-dragging');
      scrollContent.style.transform = 'translate3d(' + scrollOffset + 'px, 0, 0)';
    }

    function resumeAnimation() {
      let progress = Math.abs(scrollOffset / contentWidth) % 1;
      scrollContent.style.animationDelay = '-' + (progress * duration) + 's';
      requestAnimationFrame(function () {
        scrollContent.style.transform = '';
        scrollContent.classList.remove('is-dragging');
        scrollLine.classList.remove('is-dragging');
      });
    }

    function onDragStart(e) {
      isDragging = true;
      didDrag = false;
      pendingDiff = 0;
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      pauseAnimation();
      window.addEventListener('mousemove', onDragMove);
      window.addEventListener('touchmove', onDragMove, { passive: true });
      window.addEventListener('mouseup', onDragEnd);
      window.addEventListener('touchend', onDragEnd);
    }

    function onDragMove(e) {
      if (!isDragging) return;
      let currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      pendingDiff = currentX - startX;
      if (Math.abs(pendingDiff) > 5) didDrag = true;
      if (!dragRAF) {
        dragRAF = requestAnimationFrame(function () {
          dragRAF = null;
          scrollContent.style.transform = 'translate3d(' + wrapOffset(scrollOffset + pendingDiff) + 'px, 0, 0)';
        });
      }
    }

    function onDragEnd() {
      if (!isDragging) return;
      isDragging = false;
      if (dragRAF) { cancelAnimationFrame(dragRAF); dragRAF = null; }
      window.removeEventListener('mousemove', onDragMove);
      window.removeEventListener('touchmove', onDragMove);
      window.removeEventListener('mouseup', onDragEnd);
      window.removeEventListener('touchend', onDragEnd);

      scrollOffset = wrapOffset(scrollOffset + pendingDiff);
      resumeAnimation();
    }

    scrollLine.addEventListener('mousedown', onDragStart);
    scrollLine.addEventListener('touchstart', onDragStart, { passive: true });
    scrollContent.addEventListener('dragstart', function (e) { e.preventDefault(); });

    let wheelTimeout = null;
    let wheelRAF = null;
    scrollLine.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      let delta = e.deltaX;
      if (delta === 0) return;
      e.preventDefault();

      if (!scrollContent.classList.contains('is-dragging')) {
        pauseAnimation();
      }

      scrollOffset = wrapOffset(scrollOffset - delta);
      if (!wheelRAF) {
        wheelRAF = requestAnimationFrame(function () {
          wheelRAF = null;
          scrollContent.style.transform = 'translate3d(' + scrollOffset + 'px, 0, 0)';
        });
      }

      clearTimeout(wheelTimeout);
      wheelTimeout = setTimeout(function () {
        resumeAnimation();
      }, 150);
    }, { passive: false });

    scrollContent.addEventListener('click', function (e) {
      if (didDrag) return;
      let slide = e.target.closest('.compare-knife-series__slide');
      if (!slide) return;

      let seriesIndex = parseInt(slide.dataset.seriesIndex, 10);
      if (isNaN(seriesIndex)) return;
      if (seriesIndex === state.series1 || seriesIndex === state.series2) return;

      state.series2 = seriesIndex;
      updateContent(section, seriesIndex);
      updateSlotButton(section, btn2Icon, btn2Name, slide);
      updateBadges(slides, state);
      recalcAccordion(section);
      if (stickyHeader && stickyHeader._sync) stickyHeader._sync();
    });
  }

  function updateContent(section, seriesIndex) {
    let cells = section.querySelectorAll('[data-col="series2"] .compare-knife-series__series-content');
    cells.forEach(function (cell) {
      cell.hidden = parseInt(cell.dataset.seriesIndex, 10) !== seriesIndex;
    });
  }

  function updateBadges(slides, state) {
    slides.forEach(function (slide) {
      let idx = parseInt(slide.dataset.seriesIndex, 10);
      let isS2 = (idx === state.series2);
      let badge = slide.querySelector('[data-badge-b]');

      if (badge) {
        badge.textContent = isS2 ? 'Comparing with' : '';
        badge.classList.toggle('is-visible', isS2);
      }

      slide.classList.toggle('is-selected', isS2);
    });
  }

  function updateSlotButton(_, iconTarget, nameEl, sourceSlide) {
    if (!iconTarget || !sourceSlide) return;

    let iconData = sourceSlide.querySelector('.compare-knife-series__slide-icon-data');
    if (iconData) {
      let existingImgs = iconTarget.querySelectorAll('img, .image-box');
      existingImgs.forEach(function (el) { el.remove(); });
      let nameSpan = iconTarget.querySelector('[data-slot-name]');
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = iconData.innerHTML;
      while (tempDiv.firstChild) {
        iconTarget.insertBefore(tempDiv.firstChild, nameSpan);
      }
    }

    if (nameEl) {
      nameEl.textContent = sourceSlide.dataset.seriesName || 'Select series';
    }
  }

  function recalcAccordion(section) {
    let trigger = section.querySelector('.compare-knife-series__specs-trigger');
    let content = section.querySelector('.compare-knife-series__specs-content');
    if (trigger && content && trigger.classList.contains('is-active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  function setupSpecsAccordion(section) {
    let trigger = section.querySelector('.compare-knife-series__specs-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      let content = section.querySelector('.compare-knife-series__specs-content');
      if (!content) return;

      let isActive = trigger.classList.contains('is-active');
      if (isActive) {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      } else {
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }
})();
